import { render, staticRenderFns } from "./SelectStudyV2.vue?vue&type=template&id=a23633aa"
import script from "./SelectStudyV2.vue?vue&type=script&lang=js"
export * from "./SelectStudyV2.vue?vue&type=script&lang=js"
import style0 from "./SelectStudyV2.vue?vue&type=style&index=0&id=a23633aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports